const eyeColors = [
    { value: 'blue', label: { en: 'Blue', es: 'Azul' } },
    { value: 'green', label: { en: 'Green', es: 'Verde' } },
    { value: 'brown', label: { en: 'Brown', es: 'Marrón' } },
    { value: 'hazel', label: { en: 'Hazel', es: 'Avellana' } },
    { value: 'amber', label: { en: 'Amber', es: 'Ámbar' } },
    { value: 'gray', label: { en: 'Gray', es: 'Gris' } },
    { value: 'black', label: { en: 'Black', es: 'Negro' } },
];

export default eyeColors;